import React from 'react'
import {Box,Text, Grid, Image, Link, HStack } from '@chakra-ui/react'

const Card=({img, name, job})=>{
    return(
        <>
        <Box w='12.5rem' h='100%' display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
            <Image src={img} alt='profile' />
            <Text fontWeight='500' fontFamily='Work Sans' fontSize={['1rem','1.25rem']} textAlign='center' whiteSpace='nowrap' color='#1f1f29'>{name}</Text>
            <Text fontSize='.8rem' mt='.75rem' mb='.75rem' color='#445368' > {job}</Text>
            <HStack gap='2'>
                <Link><Image src='/twitter.png' alt='socials'/></Link>
                <Link><Image src='/linkedin.png' alt='socials'/></Link>
            </HStack>
        </Box>
        </>
    )
}

const Team = () => {
  return (
    <Box bg='#F2F4FC' w='full' h='100%' display='flex' justifyContent='center' alignItems='center' flexDirection='column' p={['1.5rem', '4rem']} >
        <Text fontSize={['1.35rem','2rem','2rem','3rem']}  mt='3rem' textAlign='center' fontFamily='Duplicate Sans' fontWeight='500'>
        Meet the Team behind NeemblePay
        </Text>
        <Text fontFamily='Work Sans'fontSize={['.75rem','1rem']} mb='1rem' lineHeight='28px'  mt='1rem' textAlign='center' color='#445368'>We are a diverse team of creative, innovative, talented and thoughtful individuals driven
       <Text as='br' display={['none','block']} /> by the desire to create solutions that are simply mind-blowing</Text>
        <Grid pb='2rem' gap='12' mt='2rem' templateColumns={['repeat(1,1fr)','repeat(2,1fr)','repeat(2,1fr)', 'repeat(4,1fr)']}>
            <Card img='/teamhead.png' name='Leonard John Davies' job='Founder, CEO'/>
            <Card img='/cl.png' name='Leonard John Davies' job='COO'/>
            <Card img='/bm.png' name='Leonard John Davies' job='Product Manager'/>
            <Card img='/tm.png' name='Leonard John Davies' job='HR'/>
            <Card img='/hm.png' name='Leonard John Davies' job='Lead Designer'/>
            <Card img='/lm.png' name='Leonard John Davies' job='Developer'/>
            <Card img='/gm.png' name='Leonard John Davies' job='Marketing'/>
        </Grid>
    </Box>
  )
}

export default Team